module.exports = __webpack_public_path__ + "assets/media/gradient-arrow-left.d8092af9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/gradient-arrow-left.svg
// module id = 3232
// module chunks = 0